import { EMPTY_ARRAY, IApplicationState, TListId } from '../../../types/types';
import { getPushNotificationSettingsByBoardId } from './getPushNotificationSettingsByBoardId';

export const getPushNotificationListChangeToIds = (
    state: IApplicationState,
    boardId: number
): TListId[] => {
    const notificationsSettings = getPushNotificationSettingsByBoardId(state, boardId);
    return notificationsSettings && notificationsSettings.listChangeToIds || EMPTY_ARRAY;
};
